import React, { useState, useEffect } from "react";

import "./profile.css";
import { Profile } from "../../components";

export const ProfilePage = () => {
  return (
    <>
      <Profile />
    </>
  );
};
